<template>
    <div class="templete no_print">
            <div class="path_title clearfix">
                <span class="path_title_name" @click="getList()">数据库备份记录 <i class="iconfont icon-shuaxin1"></i></span>
                <div class="tip_top">
                    <i class="iconfont icon-tishi1 returnImg"></i>
                    <span class="tip">备份数据文件数最多保留五条</span>
                </div>
            </div>
            <div class="path_switch">
                <el-table
                    :data="tableData"
                    :cell-style="{textAlign:'center'}"
                    :header-cell-style="{background:'#fff',color:'#333',textAlign:'center'}"
                    style="min-height: 300px;"
                    >
                        <el-table-column
                            prop="filename"
                            label="备份名称"
                            width="200">
                        </el-table-column>
                        <el-table-column
                            prop="part"
                            label="备份卷"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="size"
                            label="大小">
                        </el-table-column>
                        <el-table-column
                            prop="compress"
                            label="压缩格式">
                        </el-table-column>
                        <el-table-column
                            prop="times"
                            label="时间">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="操作">
                            <template slot-scope="scope">
                                <span class="oper_fore" @click="deteleClick(scope.row)">删除</span>
                                <span class="xianStyle">|</span>
                                <span class="oper_fore" @click="download(scope.row)">下载</span>
                            </template>
                        </el-table-column>
                </el-table>
                <div class="centetStyle">
                    <el-button class="funcPublicBtns funcPublicBtnCheckeds" @click="backups()">备份</el-button>
                </div>
            </div>
         </div>
</template>
<style scoped lang="scss">
    .templete{overflow: auto;}
    .contractLabel{float: left;position: relative;top:3px;margin-left:10px;}
    .path_title_name{float: left;font-size: 20px;cursor:pointer}
    .redQuestion{display: block;width:15px;height:15px;background: url('/icon/question.png') no-repeat 100%;background-size: 100% 100%;}
    .labelTip{display: none;position: absolute;top:20px;left:-150px;z-index:1;width:200px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
    .laCbelTipC{color:#606266;font-size: 12px;}
    .labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .path_title{text-align: left;
        font-size:16px;margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; align-items: center; }
    }
    .input_box{ width:80px; margin: 0 10px; }
    .path_switch{text-align: left;margin-bottom:20px;width: 900px;}
    .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; padding: 8px 10px;  }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .gradeSection{width:700px;flex: 1;display: flex;flex-direction: column;}
    // .starList{margin-bottom:10px;}s
    .starTableList .gradeStar{position: relative;top:5px;float: left;}
    .gradeStar{margin-right: 10px;margin-bottom:10px;}
    .path_tips{text-align: left;margin-bottom: 20px;width: 300px;background-color: #f2f2f2;padding: 10px;}
    .tip_top{color: red;font-size: 20px;}
    .returnImg{padding-left: 10px;}
    .tip{color: #777;font-size: 14px;padding-left: 5px;}
    .tipbot{padding-top: 10px;}
    .fontbold{font-weight: bold;}
 
    .funcPublicBtnCheckeds {
        background-color: #b21111!important;
        color: #fff!important;
        border-color: #b21111;
        width: 90px;
    }
    .xianStyle{color: #999;}
    .oper_fore{color: #b21111;cursor:pointer}
    .centetStyle{display: flex;justify-content: center; padding-top: 10px;}
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
               tableData:[]
            }
        },
        created(){
           this.getList()
        },
        methods:{
            //删除
            deteleClick(row){
                this.postFunc('erp/backup.delete',{time:row.time},res=>{
                    this.tip("删除成功","success")
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //下载
            download(row){
              this.$backupFile(row.time,response=>{
                    const content = response.data;
                    const blob = new Blob([content], {type: response.headers['content-type']});
                    const fileName =row.filename;
					if ('download' in document.createElement('a')) { // 非IE下载
						const elink = document.createElement('a');
						elink.download = fileName;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href); // 释放URL 对象
						document.body.removeChild(elink);
					} else { // IE10+下载
						navigator.msSaveBlob(blob);
					}
              })
            },
            //备份
            backups(){
                this.postFuncLoading('erp/backup.create',{},res=>{
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getList(){
                this.postFuncLoading('erp/backup.list',{},res=>{
                    res.data.data.forEach(item => {
                        item.times = this.formatTime(item.time+"000");
                        let limit = item.size;                        
                        var size = ""; 
                        if( limit < 0.1 * 1024 ){ //如果小于0.1KB转化成B  
                            size = limit.toFixed(2) + "B";    
                        }else if(limit < 0.1 * 1024 * 1024 ){//如果小于0.1MB转化成KB  
                            size = (limit / 1024).toFixed(2) + "KB";              
                        }else if(limit < 0.1 * 1024 * 1024 * 1024){ //如果小于0.1GB转化成MB  
                            size = (limit / (1024 * 1024)).toFixed(2) + "MB";  
                        }else{ //其他转化成GB  
                            size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";  
                        }    
                        var sizestr = size + "";   
                        var len = sizestr.indexOf("\.");  
                        var dec = sizestr.substr(len + 1, 2);  
                        if(dec == "00"){//当小数点后为00时 去掉小数部分  
                            return sizestr.substring(0,len) + sizestr.substr(len + 3,2);  
                        }  
                        item.size = sizestr;
                    });
                    this.tableData = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
          
        },
        watch:{
            
        }
    }
</script>
